export default "__VITE_ASSET__CCIyHysK__"